import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type Props = {
  show: boolean;
  onHide: () => void;
  coverAction?: string;
  redirectURL?: string;
};

export default function TraditionalCovers({
  show,
  onHide,
  coverAction = "Cancel Covers",
  redirectURL = "",
}: Props) {
  const { t } = useTranslation(["common", "components"]);

  const handleGoBack = () => {
    onHide();
  };

  const onHandleTraditionalCover = () => {
    window.open(redirectURL, "_blank");
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center d-flex flex-column align-items-center p-5">
        <p className="mb-4">
          {t("traditional_cover.message", {
            ns: "purchaseTraditionalInsurance",
            coverAction,
          })}
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <button
            className="modal-primary-button modal-secondary-button me-4"
            onClick={handleGoBack}
          >
            {t("button.go_back", { ns: "common" })}
          </button>
          <button
            className="modal-primary-button"
            onClick={onHandleTraditionalCover}
          >
            {t("button.proceed", { ns: "common" })}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
